import { FC } from "react";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import {
  landingActiveStepAtom,
  LandingStepEnum,
  useLandingActions,
  useLandingLangSwitch,
} from "@ryde/utils-landings";

import {
  StepChooseStationClal,
  StepErrorClal,
  StepFinishedClal,
  StepLoginClal,
  StepVerifyCodeClal,
} from "../../steps-clal";

export const ClalLandingStepsContainer: FC = () => {
  const step = useRecoilValue(landingActiveStepAtom);
  const { goToStep } = useLandingActions();
  useLandingLangSwitch();

  return (
    <main className="landing-outside-container">
      <div className="landing-container">
        <button
          type="button"
          className="landing-logo"
          onClick={() => goToStep(LandingStepEnum.LoginStep)}
          aria-label="Go to homepage"
        >
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.ClalLogoPNG}
            alt="Clal logo"
            width="206"
            height="117"
          />
        </button>
        {(!step || step === LandingStepEnum.LoginStep) && <StepLoginClal />}
        {step === LandingStepEnum.VerificationStep && <StepVerifyCodeClal />}
        {step === LandingStepEnum.ChooseStationStep && (
          <StepChooseStationClal />
        )}
        {step === LandingStepEnum.FinishedStep && <StepFinishedClal />}
        {step === LandingStepEnum.ErrorStep && <StepErrorClal />}
      </div>
    </main>
  );
};
